import { FilePanel } from "components";
import { Box, Button, formatFileSize, Grid, RichTextReader, Stack, Typography } from "@compass/core";
import { DefaultExtensionType, FileIcon as ReactFileIcon, defaultStyles } from "react-file-icon";
import PreviewIcon from "@mui/icons-material/Preview";
import { ApplicationResponseFile } from "generated/openApi";
import ApiService from "services/apiService";

export type FileListItemProps = {
  file: ApplicationResponseFile;
  fileCategory?: string;
  index: Number;
};

export const FileListItem = ({
  file,
  fileCategory,
  index
}: FileListItemProps) => {
  const iconWidth = "35px";
  const thumbnailSize = "42px";
  const extension: string | undefined = file.uploadFile?.fileName.split(".").pop();

  const getFile = async () => {
    const open = true;
    if (file.uploadFile.fileRef && file.uploadFile.fileName) {
      const fileRef = file.uploadFile.fileRef;
      const fileName = file.uploadFile.fileName;

      ApiService.common.getFile(fileRef, fileName).then((response) => {
        const blob = response!.data;
        const url = window.URL.createObjectURL(blob);

        if (open) {
          window.open(url, "_blank");
        } else {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  };

  return (
    <Grid item xs={12}>
      <Grid container spacing="sm">
        <Grid item xs={1}>
          <Box display="inline-flex" width={iconWidth} height={thumbnailSize}>
            <ReactFileIcon extension={extension} {...defaultStyles[extension as DefaultExtensionType]} />
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Stack direction="column">
            <Typography
              variant="inherit"
              lineHeight={"100%"}
              sx={{
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}>
              {file.uploadFile?.fileName}
            </Typography>
            <Typography variant="caption">{formatFileSize(file.uploadFile?.fileSize)}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={2}>
          <Stack direction="column">
            <Typography variant="caption">Category:</Typography>
            <Typography
              variant="inherit"
              lineHeight={"100%"}
              sx={{
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}>
              {fileCategory || "N/A"}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack direction="column">
            <Typography variant="caption">Notes:</Typography>
            <RichTextReader html={file.note} />
          </Stack>
        </Grid>
        <Grid item xs={1}>
          <Button
            onClick={() => { getFile() }}
          >
            <Stack direction="row">
              <PreviewIcon />
              <Typography variant="inherit" sx={{ paddingLeft: "10px" }}>
                View
              </Typography>
            </Stack>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
